import styled from "styled-components";
import themes from "~/themes";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1450px;
  margin-top: 20px;
`;

export const TitleStyle = styled.span`
  color: #bbbbbb;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WrapperLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
`;
